// Compress and resize images client-side before upload
// Reduces base64 payload from ~5MB per photo to ~200-500KB

const MAX_WIDTH = 1600;   // pixels
const QUALITY = 0.78;      // JPEG quality

export function compressImageFile(file, maxWidth = MAX_WIDTH, quality = QUALITY) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      reject(new Error('Arquivo não é uma imagem'));
      return;
    }

    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Erro ao ler arquivo'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('Erro ao decodificar imagem'));
      img.onload = () => {
        try {
          let { width, height } = img;
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          const dataUrl = canvas.toDataURL('image/jpeg', quality);
          resolve({ dataUrl, width, height, name: file.name });
        } catch (e) {
          reject(e);
        }
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

export async function compressAll(files, onProgress) {
  const arr = Array.from(files);
  const results = [];
  for (let i = 0; i < arr.length; i++) {
    try {
      const r = await compressImageFile(arr[i]);
      results.push(r);
    } catch (e) {
      console.error('compress fail', arr[i]?.name, e);
    }
    if (onProgress) onProgress(i + 1, arr.length);
  }
  return results;
}
